import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import ForgotPasswordGuard from './component/ForgotPasswordGuard';
import SignIn from './SiginIn';
import Home from './Home';
import PublicRoute from './PublicRoute';
import PrivateRoute from './PrivateRoute';
import PrivateRouteWithPrivilege from './component/RoutePrivilege';
import ForgotPasswordSendOtp from './pages/password/ForgotPasswordSendOtp';
import ForgotPasswordVerifyOtp from './pages/password/ForgotPasswordVerifyOtp';
import ForgotPasswordReset from './pages/password/ForgotPasswordReset';
import Verification from 'Verification';
import ManageProfile from './pages/profile/ManageProfile';
import ChangePassword from './pages/profile/ChangePassword';
import SignUp from 'SignUp';
import Project from 'pages/project/Project';
import Assist from 'pages/assist/Assist';
import ChangePhoneNumberActivation from 'pages/assist/ChangePhoneNumberActivation';
import Client from 'pages/client/Client';
import Principal from 'pages/principal/Principal';
import Store from 'pages/store/Store';
import Dashboard from 'pages/dashboard/Dashboard';
import Calendar from 'pages/calendar/Calendar';
import Area from 'pages/area/Area';
import Poi from 'pages/poi/Poi';
import PoiForm from 'pages/poi/PoiForm';
import Goods from 'pages/goods/Goods';
import Installer from 'pages/installer/Installer';
import User from 'pages/user/User';
import Form from 'pages/form/Forms';

import Disbursement from 'pages/disbursement/disbursement';
import ClientForm from 'pages/client/ClientForm';
import PrincipalForm from 'pages/principal/PrincipalForm';
import StoreForm from 'pages/store/StoreForm';
import GoodsForm from 'pages/goods/GoodsForm';
import InstallerForm from 'pages/installer/InstallerForm';
import UserForm from 'pages/user/UserForm';

import Version from 'pages/version/version';
import VersionForm from 'pages/version/VersionForm';
import FormFactory from 'pages/form/FormsFactory';
import FormGroupFactory from 'pages/form/FormGroupFactory';
import ProjectForm from 'pages/project/ProjectForm';
import ProjectDetail from 'pages/project/ProjectDetail';
import ProjectTaskForm from 'pages/project/ProjectTaskForm';
import ProjectAdvanceAssignment from 'pages/project/ProjectAdvanceAssignment';
import ProjectJobCreation from 'pages/project/ProjectJobCreation';
import Monitor from 'pages/monitor/Monitor';
import MonitorOverview from 'pages/monitor/MonitorOverview';
import FieldDataMonitor from 'pages/monitor/FieldDataMonitor';
import BankAccountRegistration from 'pages/amarbank/BankAccountRegistration';
import QrisTransactionStatus from 'pages/amarbank/QrisTransactionStatus';
import TimeDepositStatus from 'pages/amarbank/TimeDepositStatus';
import TransferStatus from 'pages/amarbank/TransferStatus';
import RetailPartner from 'pages/retailpartner/RetailPartner';
import RetailPartnerForm from 'pages/retailpartner/RetailPartnerForm';
import ReportEngine from 'pages/reportEngine/ReportEngine';
import ReportEngineInformation from 'pages/reportEngine/ReportEngineInformation';
import ReportEngineForm from 'pages/reportEngine/ReportEngineForm';
import RoleAccess from 'pages/RBAC/RoleAccess';
import ManageRoleAccess from 'pages/RBAC/ManageRoleAccess';
import RunnerEngine from 'pages/runnerEngine/RunnerEngine';
import RunnerEngineForm from 'pages/runnerEngine/RunnerEngineForm';
import ProjectJobDetail from 'pages/project/ProjectJobDetail';
import Transaction from 'pages/transaction/Transaction';
import TransactionForm from 'pages/transaction/TransactionForm';
import SystemParameter from 'pages/systemParameter/SystemParameter';
import SystemParameterForm from 'pages/systemParameter/SystemParameterForm';
import ProjectConfig from 'pages/clientTransmora/projectConfig/ProjectConfig';
import ProjectConfigForm from 'pages/clientTransmora/projectConfig/ProjectConfigForm';
import ProjectKey from 'pages/clientTransmora/projectKey/ProjectKey';
import ProjectKeyForm from 'pages/clientTransmora/projectKey/ProjectKeyForm';
import ProjectLayout from 'pages/clientTransmora/projectLayout/ProjectLayout';
import ProjectLayoutForm from 'pages/clientTransmora/projectLayout/ProjectLayoutForm';
import ProjectFilter from 'pages/clientTransmora/projectFilter/ProjectFilter';
import ProjectFilterForm from 'pages/clientTransmora/projectFilter/ProjectFilterForm';
import ProjectMetric from 'pages/clientTransmora/projectMetric/ProjectMetric';
import ProjectMetricForm from 'pages/clientTransmora/projectMetric/ProjectMetricForm';
import ProjectUser from 'pages/clientTransmora/projectUser/ProjectUser';
import ProjectUserForm from 'pages/clientTransmora/projectUser/ProjectUserForm';

import HomeShortcut from 'pages/homeshortcut/HomeShortcut';

import HomeShortcutForm from 'pages/homeshortcut/HomeShortcutForm'
import Ppob from 'pages/PPOB/Ppob';
import PpobProductItem from 'pages/PPOB/PpobProductItem';
import PpobDetail from 'pages/PPOB/PpobDetail';
import PpobHistory from 'pages/PPOB/PpobHistory';

import Tribe from 'pages/tribe/Tribe';
import TribeForm from 'pages/tribe/TribeForm';
import StoreDirectorySupplyMonitor from 'pages/clientTransmora/storeDirectorySupplyMonitor/StoreDirectorySupplyMonitor';
import QCMonitor from 'pages/qcMonitor/QCMonitor';
import UserGrowthMonitor from 'pages/userGrowthMonitor/UserGrowthMonitor';
import CoverageAnalysis from 'pages/coverageAnalysis/CoverageAnalysis';
import FieldVisitAssist from 'pages/assist/FieldVisitAssist';
import FieldVisitDetailModal from 'component/FieldVisitDetailModal';
import DistributionHub from 'pages/distributionHub/DistributionHub';
import DistributionHubForm from 'pages/distributionHub/DistributionHubForm';
import Notification from 'pages/notification/Notification';
import NexusDistributor from 'pages/nexusDistributor/NexusDistributor';
import NexusDistributorForm from 'pages/nexusDistributor/NexusDistributorForm';

const App: React.FC = () => {
  return (
    <div style={{ height: "100%", minHeight: "100vh" }}>
      <Routes>
        <Route
          path="/signin"
          element={
            <PublicRoute>
              <SignIn />
            </PublicRoute>
          }
        />
        <Route
          path="/signup"
          element={
            <PublicRoute>
              <SignUp />
            </PublicRoute>
          }
        />
        <Route
          path="/forgot-password-send-otp"
          element={
            <PublicRoute>
              <ForgotPasswordSendOtp />
            </PublicRoute>
          }
        />
        <Route
          path="/forgot-password-verify-otp"
          element={
            <PublicRoute>
              <ForgotPasswordGuard step="verify">
                <ForgotPasswordVerifyOtp />
              </ForgotPasswordGuard>
            </PublicRoute>
          }
        />

        <Route
          path="/forgot-password-reset"
          element={
            <PublicRoute>
              <ForgotPasswordGuard step="reset">
                <ForgotPasswordReset />
              </ForgotPasswordGuard>
            </PublicRoute>
          }
        />
        <Route
          path="/verification"
          element={
            <PublicRoute>
              <Verification />
            </PublicRoute>
          }
        />

        <Route element={
          <PrivateRoute>
            <Home />
          </PrivateRoute>
        }>
          <Route
            path="/change-password"
            element={
              <PrivateRoute>
                <ChangePassword />
              </PrivateRoute>
            }
          />
          <Route
            path="/manage-profile"
            element={
              <PrivateRoute>
                <ManageProfile />
              </PrivateRoute>
            }
          />
          <Route path="/notifications" element={
            <PrivateRoute>
              <Notification />
            </PrivateRoute>
          } />
          <Route path="/dashboard" element={
            <PrivateRouteWithPrivilege vgroup="dashboard" action="view">
              <Dashboard />
            </PrivateRouteWithPrivilege>
          } />
          <Route path="/monitor/overview" element={
            <PrivateRouteWithPrivilege vgroup="monitor" action="view">
              <MonitorOverview />
            </PrivateRouteWithPrivilege>
          } />
          <Route path="/monitor/:projectId/data" element={
            <PrivateRouteWithPrivilege vgroup="monitor" action="view">
              <FieldDataMonitor />
            </PrivateRouteWithPrivilege>
          } />
          <Route path="/monitor/:projectId" element={
            <PrivateRouteWithPrivilege vgroup="monitor" action="view">
              <Monitor />
            </PrivateRouteWithPrivilege>
          } />
          <Route path="/qc-monitor" element={
            <PrivateRoute>
              <QCMonitor />
            </PrivateRoute>
          } />
          <Route path="/growth-monitor" element={
            <PrivateRouteWithPrivilege vgroup="monitor_growth" action="view">
              <UserGrowthMonitor />
            </PrivateRouteWithPrivilege>
          } />
          <Route path="/coverage-analysis" element={
            <PrivateRoute>
              <CoverageAnalysis />
            </PrivateRoute>
          } />
          <Route path="/project" element={
            <PrivateRouteWithPrivilege vgroup="project" action="view">
              <Project />
            </PrivateRouteWithPrivilege>
          } />
          <Route path="/calendar" element={
            <PrivateRoute>
              <Calendar />
            </PrivateRoute>
          } />
          <Route path="/assist" element={
            <PrivateRouteWithPrivilege vgroup="project" action="view">
              <Assist />
            </PrivateRouteWithPrivilege>
          } />
          <Route path="/assist-change-phone-number-activation" element={
            <PrivateRouteWithPrivilege vgroup="project" action="view">
              <ChangePhoneNumberActivation />
            </PrivateRouteWithPrivilege>
          } />
          <Route path="/assist-field-visit" element={
            <PrivateRouteWithPrivilege vgroup="project" action="view">
              <FieldVisitAssist />
            </PrivateRouteWithPrivilege>
          } />
          <Route path="/project/detail/:id" element={
            <PrivateRouteWithPrivilege vgroup="project" action="view">
              <ProjectDetail />
            </PrivateRouteWithPrivilege>
          } />
          <Route path="/project/detail/:id/advance-assignment" element={
            <PrivateRouteWithPrivilege vgroup="project" action="view">
              <ProjectAdvanceAssignment />
            </PrivateRouteWithPrivilege>
          } />
          <Route path="/project/detail/:id/job-creation" element={
            <PrivateRouteWithPrivilege vgroup="project" action="create">
              <ProjectJobCreation />
            </PrivateRouteWithPrivilege>
          } />
          <Route path="/project/assignment/:id" element={
            <PrivateRouteWithPrivilege vgroup="project" action="update">
              <ProjectTaskForm />
            </PrivateRouteWithPrivilege>
          } />
          <Route path="/project/assignment/:id" element={
            <PrivateRouteWithPrivilege vgroup="project" action="update">
              <ProjectJobDetail />
            </PrivateRouteWithPrivilege>
          } />
          <Route path="/project/:id" element={
            <PrivateRouteWithPrivilege vgroup="project" action="update">
              <ProjectForm />
            </PrivateRouteWithPrivilege>
          } />

          <Route path="/client" element={
            <PrivateRouteWithPrivilege vgroup="client" action="view">
              <Client />
            </PrivateRouteWithPrivilege>
          } />
          <Route path="/client/:id" element={
            <PrivateRouteWithPrivilege vgroup="client" action="update">
              <ClientForm />
            </PrivateRouteWithPrivilege>
          } />

          <Route path="/principal" element={
            <PrivateRouteWithPrivilege vgroup="principal" action="view">
              <Principal />
            </PrivateRouteWithPrivilege>
          } />
          <Route path="/principal/:id" element={
            <PrivateRouteWithPrivilege vgroup="principal" action="update">
              <PrincipalForm />
            </PrivateRouteWithPrivilege>
          } />

          <Route path="/store" element={
            <PrivateRouteWithPrivilege vgroup="store" action="view">
              <Store />
            </PrivateRouteWithPrivilege>
          } />
          <Route path="/store/:id" element={
            <PrivateRouteWithPrivilege vgroup="store" action="update">
              <StoreForm />
            </PrivateRouteWithPrivilege>
          } />

          <Route path="/area" element={
            <PrivateRouteWithPrivilege vgroup="area" action="view">
              <Area />
            </PrivateRouteWithPrivilege>
          } />

          <Route path="/poi" element={
            <PrivateRouteWithPrivilege vgroup="poi" action="view">
              <Poi />
            </PrivateRouteWithPrivilege>
          } />
          <Route path="/poi/:id" element={
            <PrivateRouteWithPrivilege vgroup="poi" action="update">
              <PoiForm />
            </PrivateRouteWithPrivilege>
          } />

          <Route path="/goods" element={
            <PrivateRouteWithPrivilege vgroup="goods" action="view">
              <Goods />
            </PrivateRouteWithPrivilege>
          } />
          <Route path="/goods/:id" element={
            <PrivateRouteWithPrivilege vgroup="goods" action="update">
              <GoodsForm />
            </PrivateRouteWithPrivilege>
          } />

          <Route path="/installer" element={
            <PrivateRouteWithPrivilege vgroup="installer" action="view">
              <Installer />
            </PrivateRouteWithPrivilege>
          } />
          <Route path="/installer/:id" element={
            <PrivateRouteWithPrivilege vgroup="installer" action="update">
              <InstallerForm />
            </PrivateRouteWithPrivilege>
          } />

          <Route path="/user" element={
            <PrivateRouteWithPrivilege vgroup="user" action="view">
              <User />
            </PrivateRouteWithPrivilege>
          } />
          <Route path="/user/:id" element={
            <PrivateRouteWithPrivilege vgroup="user" action="update">
              <UserForm />
            </PrivateRouteWithPrivilege>
          } />

          <Route path="/retail-partner" element={
            <PrivateRouteWithPrivilege vgroup="merchant_partner" action="view">
              <RetailPartner />
            </PrivateRouteWithPrivilege>
          } />
          <Route path="/retail-partner/:id" element={
            <PrivateRouteWithPrivilege vgroup="merchant_partner" action="update">
              <RetailPartnerForm />
            </PrivateRouteWithPrivilege>
          } />



          <Route path="/form" element={
            <PrivateRouteWithPrivilege vgroup="form" action="view">
              <Form />
            </PrivateRouteWithPrivilege>
          } />
          <Route path="/form/:id" element={
            <PrivateRouteWithPrivilege vgroup="form" action="update">
              <FormFactory />
            </PrivateRouteWithPrivilege>
          } />
          <Route path="/form-group/:id" element={
            <PrivateRouteWithPrivilege vgroup="form" action="update">
              <FormGroupFactory />
            </PrivateRouteWithPrivilege>
          } />

          <Route path="/transaction" element={
            <PrivateRouteWithPrivilege vgroup="transaction" action="view">
              <Transaction />
            </PrivateRouteWithPrivilege>
          } />
          <Route path="/transaction/:id" element={
            <PrivateRouteWithPrivilege vgroup="transaction" action="view">
              <TransactionForm />
            </PrivateRouteWithPrivilege>
          } />

          <Route path="/system-parameter" element={
            <PrivateRouteWithPrivilege vgroup="system_parameter" action="view">
              <SystemParameter />
            </PrivateRouteWithPrivilege>
          } />
          <Route path="/system-parameter/:id" element={
            <PrivateRouteWithPrivilege vgroup="system_parameter" action="update">
              <SystemParameterForm />
            </PrivateRouteWithPrivilege>
          } />
          <Route path='/tribe' element={
            <PrivateRouteWithPrivilege vgroup="tribe" action="view">
              <Tribe />
            </PrivateRouteWithPrivilege>
          } />
          <Route path='/tribe/:id' element={
            <PrivateRouteWithPrivilege vgroup="tribe" action="update">
              <TribeForm />
            </PrivateRouteWithPrivilege>
          } />

          <Route path="/distribution-hub" element={
            <PrivateRouteWithPrivilege vgroup="distribution_hub" action="view">
              <DistributionHub />
            </PrivateRouteWithPrivilege>
          } />
          <Route path="/distribution-hub/:id" element={
            <PrivateRouteWithPrivilege vgroup="distribution_hub" action="update">
              <DistributionHubForm />
            </PrivateRouteWithPrivilege>
          } />

          <Route path="/rbac" element={
            <PrivateRouteWithPrivilege vgroup="role_access" action="view">
              <RoleAccess />
            </PrivateRouteWithPrivilege>
          } />
          <Route path="/rbac/:id" element={
            <PrivateRouteWithPrivilege vgroup="role_access" action="manage">
              <ManageRoleAccess />
            </PrivateRouteWithPrivilege>
          } />



          <Route path="/version" element={
            <PrivateRouteWithPrivilege vgroup="version" action="view">
              <Version />
            </PrivateRouteWithPrivilege>
          } />
          <Route path="/version/:id" element={
            <PrivateRouteWithPrivilege vgroup="version" action="update">
              <VersionForm />
            </PrivateRouteWithPrivilege>
          } />

          <Route path="/mobile-shortcut" element={
            <PrivateRouteWithPrivilege vgroup="home_shortcut" action="view">
              <HomeShortcut />
            </PrivateRouteWithPrivilege>
          } />

          <Route path="/mobile-shortcut/:id" element={
            <PrivateRouteWithPrivilege vgroup="home_shortcut" action="view">
              <HomeShortcutForm />
            </PrivateRouteWithPrivilege>
          } />

          <Route path="/ppob" element={
            <PrivateRouteWithPrivilege vgroup="ppob" action="view">
              <Ppob />
            </PrivateRouteWithPrivilege>
          } />

          <Route path="/ppob/items" element={
            <PrivateRouteWithPrivilege vgroup="ppob" action="view">
              <PpobProductItem />
            </PrivateRouteWithPrivilege>
          } />

          <Route path="/ppob/history" element={
            <PrivateRouteWithPrivilege vgroup="ppob" action="view">
              <PpobHistory />
            </PrivateRouteWithPrivilege>
          } />

          <Route path="/ppob/:id" element={
            <PrivateRouteWithPrivilege vgroup="ppob" action="view">
              <PpobDetail />
            </PrivateRouteWithPrivilege>
          } />

          <Route path="/disbursement" element={
            <PrivateRouteWithPrivilege vgroup="disbursement" action="view">
              <Disbursement />
            </PrivateRouteWithPrivilege>
          } />
          <Route path="/report-engine" element={
            <PrivateRouteWithPrivilege vgroup="report_engine" action="view">
              <ReportEngine />
            </PrivateRouteWithPrivilege>
          } />
          <Route path="/report-engine-information/:id" element={
            <PrivateRouteWithPrivilege vgroup="report_engine" action="view">
              <ReportEngineInformation />
            </PrivateRouteWithPrivilege>
          } />
          <Route path="/report-engine/:id" element={
            <PrivateRouteWithPrivilege vgroup="report_engine" action="update">
              <ReportEngineForm />
            </PrivateRouteWithPrivilege>
          } />
          <Route path="/runner-engine" element={<RunnerEngine />} />
          <Route path="/runner-engine/:id" element={<RunnerEngineForm />} />

          <Route path="/client-project-config" element={
            <PrivateRouteWithPrivilege vgroup="project" action="view">
              <ProjectConfig />
            </PrivateRouteWithPrivilege>
          } />
          <Route path="/client-project-config/:id" element={
            <PrivateRouteWithPrivilege vgroup="project" action="view">
              <ProjectConfigForm />
            </PrivateRouteWithPrivilege>
          } />

          <Route path="/client-project-key" element={
            <PrivateRouteWithPrivilege vgroup="project" action="view">
              <ProjectKey />
            </PrivateRouteWithPrivilege>
          } />
          <Route path="/client-project-key/:projectId" element={
            <PrivateRouteWithPrivilege vgroup="project" action="view">
              <ProjectKeyForm />
            </PrivateRouteWithPrivilege>
          } />

          <Route path="/client-project-layout" element={
            <PrivateRouteWithPrivilege vgroup="project" action="view">
              <ProjectLayout />
            </PrivateRouteWithPrivilege>
          } />
          <Route path="/client-project-layout/:id" element={
            <PrivateRouteWithPrivilege vgroup="project" action="view">
              <ProjectLayoutForm />
            </PrivateRouteWithPrivilege>
          } />

          <Route path="/client-project-filter" element={
            <PrivateRouteWithPrivilege vgroup="project" action="view">
              <ProjectFilter />
            </PrivateRouteWithPrivilege>
          } />
          <Route path="/client-project-filter/:id" element={
            <PrivateRouteWithPrivilege vgroup="project" action="view">
              <ProjectFilterForm />
            </PrivateRouteWithPrivilege>
          } />

          <Route path="/client-project-metric" element={
            <PrivateRouteWithPrivilege vgroup="project" action="view">
              <ProjectMetric />
            </PrivateRouteWithPrivilege>
          } />
          <Route path="/client-project-metric/:id" element={
            <PrivateRouteWithPrivilege vgroup="project" action="view">
              <ProjectMetricForm />
            </PrivateRouteWithPrivilege>
          } />

          <Route path="/client-project-user" element={
            <PrivateRouteWithPrivilege vgroup="client_project_user" action="view">
              <ProjectUser />
            </PrivateRouteWithPrivilege>
          } />
          <Route path="/client-project-user/:id" element={
            <PrivateRouteWithPrivilege vgroup="client_project_user" action="view">
              <ProjectUserForm />
            </PrivateRouteWithPrivilege>
          } />

          <Route path="/nexus-distributor" element={
            <PrivateRouteWithPrivilege vgroup="nexus_distributor" action="view">
              <NexusDistributor />
            </PrivateRouteWithPrivilege>
          } />
          <Route path="/nexus-distributor/:id" element={
            <PrivateRouteWithPrivilege vgroup="nexus_distributor" action="view">
              <NexusDistributorForm />
            </PrivateRouteWithPrivilege>
          } />

          <Route path="/store-directory-supply-monitor" element={
            <PrivateRouteWithPrivilege vgroup="project" action="view">
              <StoreDirectorySupplyMonitor />
            </PrivateRouteWithPrivilege>
          } />

          <Route path="/bankAccount" element={
            <PrivateRouteWithPrivilege vgroup="amar_bank_account_registration" action="view">
              <BankAccountRegistration />
            </PrivateRouteWithPrivilege>
          } />
          <Route path="/qristransaction" element={
            <PrivateRouteWithPrivilege vgroup="amar_qris_transaction_status" action="view">
              <QrisTransactionStatus />
            </PrivateRouteWithPrivilege>
          } />
          <Route path="/timeDeposit" element={
            <PrivateRouteWithPrivilege vgroup="amar_time_deposit_status" action="view">
              <TimeDepositStatus />
            </PrivateRouteWithPrivilege>
          } />
          <Route path="/transferStatus" element={
            <PrivateRouteWithPrivilege vgroup="amar_transfer_status" action="view">
              <TransferStatus />
            </PrivateRouteWithPrivilege>
          } />
        </Route>

        <Route path="/" element={<Navigate to="/dashboard" replace />} />

        <Route path="/unauthorized" element={
          <div className="container mt-5">
            <div className="row justify-content-center">
              <div className="text-center col-md-6">
                <div className="alert alert-danger">
                  <h4>Access Denied</h4>
                  <p>You don't have permission to access this page.</p>
                  <button
                    className="btn btn-primary"
                    onClick={() => window.history.back()}
                  >
                    Go Back
                  </button>
                </div>
              </div>
            </div>
          </div>
        } />

        <Route path="*" element={
          <div className="container mt-5">
            <div className="row justify-content-center">
              <div className="text-center col-md-6">
                <div className="alert alert-warning">
                  <h4>Page Not Found</h4>
                  <p>The page you're looking for doesn't exist.</p>
                  <button
                    className="btn btn-primary"
                    onClick={() => window.location.href = '/dashboard'}
                  >
                    Go to Dashboard
                  </button>
                </div>
              </div>
            </div>
          </div>
        } />
      </Routes>
    </div>
  );
};

export default App;